import { mediumFont } from "@app/styles";
import styled from "styled-components";

export const ToastOuterContainer = styled.div`
  .kazoo_toast {
    .Toastify__toast {
      box-shadow: 0 4px 15px rgba(0, 0, 0, 0.3);
      min-width: 300px;
      width: auto;
      max-width: 500px;
      min-height: 60px;
    }
  }
`;
export const ToastInnerContainer = styled.div`
  display: flex;
  align-items: flex-start;
  padding: 16px;
  line-height: 1.5;
  color: #767b8a;
`;

export const IconContainer = styled.div`
  display: flex;
  align-items: center;
  svg {
    height: 24px;
    width: 24px;
  }
`;

export const MessageContainer = styled.div`
  padding-left: 16px;
`;

export const Title = styled.div`
  margin-bottom: 6px;
  color: #222222;
  font-size: 1rem;
  ${mediumFont}
`;

export const ToastMessage = styled.div`
  font-size: 0.8rem;
`;
